<template>
    <div class="memo-view-wrapper">
        <component :is="currentSystem" v-if="!loading" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import SingleSystemMemoView from './SingleSystemMemoView';
import RhymeSystemMemoView from './RhymeSystemMemoView';
import AlphabetSystemMemoView from './AlphabetSystemMemoView';
import DoubleSystemMemoView from './DoubleSystemMemoView';
import OlpaSystemMemoView from './OlpaSystemMemoView';
import NameSystemMemoView from './NameSystemMemoView';

export default {
    data() {
        return {
            systems: [
                {
                    id: 'singlesys',
                    component: SingleSystemMemoView
                },
                {
                    id: 'rhymesys',
                    component: RhymeSystemMemoView
                },
                {
                    id: 'alphabetsys',
                    component: AlphabetSystemMemoView
                },
                {
                    id: 'doublesys',
                    component: DoubleSystemMemoView
                },
                {
                    id: 'olpasys',
                    component: OlpaSystemMemoView
                },
                {
                    id: 'namesys',
                    component: NameSystemMemoView
                }
            ],
            loading: true
        };
    },

    computed: {
        currentSystem() {
            return this.systems.find(system => system.id === this.$route.params.systemId).component;
        }
    },

    async mounted() {
        await this.loadSystems();
        this.loading = false;
    },

    methods: {
        ...mapActions({ loadSystems: 'moduleCourse/loadSystems' })
    }
};
</script>

<style lang="scss" scoped>
.memo-view-wrapper {
    background-image: url('~@/assets/images/background.png');
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}
</style>
